"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "tornolo": {
    "0b153789": [{
      "hkey": "cabc33b1",
      "slug": "tornolo",
      "name": "Tornolo",
      "primary": true,
      "skipSearch": false
    }],
    "crocetta-di-tarsogno": [{
      "hkey": "cabc33b1",
      "slug": "tornolo",
      "name": "Tornolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3b423399": [{
      "hkey": "cabc33b1",
      "slug": "tornolo",
      "name": "Tornolo",
      "primary": true,
      "skipSearch": false
    }],
    "passo-di-cento-croci": [{
      "hkey": "cabc33b1",
      "slug": "tornolo",
      "name": "Tornolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e77e3c72": [{
      "hkey": "cabc33b1",
      "slug": "tornolo",
      "name": "Tornolo",
      "primary": true,
      "skipSearch": false
    }],
    "ravezza": [{
      "hkey": "cabc33b1",
      "slug": "tornolo",
      "name": "Tornolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;